
















































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { storePasien } from "@/store/modules/pasien";
import moment from "moment";
import BeratBadan from "@/components/pemeriksaan/assesmen/BeratBadan.vue";
import TinggiBadan from "@/components/pemeriksaan/assesmen/TinggiBadan.vue";
import TekananDarah from "@/components/pemeriksaan/assesmen/TekananDarah.vue";
import GolonganDarah from "@/components/pemeriksaan/assesmen/GolonganDarah.vue";
import { storeAssesmenRalan } from "@/store/modules/asesmenralan";
import { SuketSehatJasmaniInterface } from "@/types/suket_sehat_jasmani";
import SuketSehatJasmani from "@/services/SuketSehatJasmani";
import StoreSuketSehatJasmani from "@/store/modules/SuketSehatJasmani";
import FormPrefillService from "@/services/FormPrefillService";

const FORM_KEY = "surat_sehat_jasmani";
const PREFILL_SOURCES = ["klinis_terkini"];

function teks(v: unknown): string {
  return v === null || v === undefined ? "" : String(v).trim();
}

@Component({
  components: {
    CardModalTtd,
    BeratBadan,
    TinggiBadan,
    TekananDarah,
    GolonganDarah
  },
  inject: { isReadOnly: { default: () => () => false } }
})
export default class CardInputSKSehatJasmani extends Vue {
  @Prop() readonly register!: string;
  @Prop() dataSuket!: SuketSehatJasmaniInterface;

  isReadOnly!: () => boolean;
  get readOnly(): boolean {
    return this.isReadOnly();
  }

  register_id = this.dataSuket?.register_id || this.register;
  unit_id = this.dataSuket?.unit_id || this.user.unit_id;
  dokter_id = this.dataSuket?.dokter_id || this.user.id;
  pasien_rm = this.dataSuket?.pasien_rm || this.statePasien.rm;
  nama = this.dataSuket?.nama || this.statePasien.nama;
  tgl_lahir = this.dateFormat(this.statePasien.tgl_lahir);
  alamat = this.dataSuket?.alamat || this.statePasien.alamat;
  keterangan = this.dataSuket?.keterangan || "1";
  tujuan = this.dataSuket?.tujuan || "";
  keterangan_tambahan = this.dataSuket?.keterangan_tambahan || "";
  td = this.dataSuket?.td || this.tensiAsesmen || "";
  tb = this.dataSuket?.tb || this.tbAsesmen || "";
  bb = this.dataSuket?.bb || this.bbAsesmen || "";
  nadi = this.dataSuket?.nadi || this.nadiAsesmen || "";
  imt = this.dataSuket?.imt || "";
  gol_darah = this.dataSuket?.gol_darah || this.statePasien.gol_darah;

  validasi = [v => !!v || "*Kolom ini harus diisi"];
  modalTtd = false;
  saving = false;
  tarikLoading = false;
  tglLahirShow = false;
  golDarahOptions = [
    {
      text: "A",
      value: "A"
    },
    {
      text: "B",
      value: "B"
    },
    {
      text: "AB",
      value: "AB"
    },
    {
      text: "O",
      value: "O"
    },
    {
      text: "A+",
      value: "A+"
    },
    {
      text: "A-",
      value: "A-"
    },
    {
      text: "B+",
      value: "B+"
    },
    {
      text: "B-",
      value: "B-"
    },
    {
      text: "AB+",
      value: "AB+"
    },
    {
      text: "AB-",
      value: "AB-"
    },
    {
      text: "O+",
      value: "O+"
    },
    {
      text: "O-",
      value: "O-"
    }
  ];

  get statePasien() {
    return storePasien.identitasPasien;
  }

  get stateAsesmenAwal() {
    return storeAssesmenRalan.asesmenAwal;
  }

  get user() {
    return userModule.user;
  }

  get input() {
    return {
      register_id: this.register,
      unit_id: this.unit_id,
      dokter_id: this.dokter_id,
      pasien_rm: this.pasien_rm,
      nama: this.nama,
      tgl_lahir: this.tgl_lahir,
      alamat: this.alamat,
      keterangan: this.keterangan,
      tujuan: this.tujuan,
      keterangan_tambahan: this.keterangan_tambahan,
      td: this.td,
      nadi: this.nadi,
      tb: this.tb,
      bb: this.bb,
      imt: this.imt,
      gol_darah: this.gol_darah
    };
  }

  get tensiAsesmen() {
    const asesmen = this.stateAsesmenAwal;
    const sistole = asesmen ? asesmen["tanda_vital"]?.sistole : null;
    const diastole = asesmen ? asesmen["tanda_vital"]?.diastole : null;

    return sistole || diastole ? `${sistole}/${diastole}` : null;
  }

  get tbAsesmen() {
    const asesmen = this.stateAsesmenAwal;

    return asesmen ? asesmen["antropometri"]?.tinggi_badan : null;
  }

  get bbAsesmen() {
    const asesmen = this.stateAsesmenAwal;

    return asesmen ? asesmen["antropometri"]?.berat_badan : null;
  }

  get nadiAsesmen() {
    const asesmen = this.stateAsesmenAwal;
    return asesmen ? asesmen["tanda_vital"]?.frekuensi_nadi : null;
  }

  setBb(v) {
    this.bb = v;
  }

  setTb(v) {
    this.tb = v;
  }

  async tarikDariTtv() {
    if (this.tarikLoading || this.readOnly) return;
    this.tarikLoading = true;

    try {
      const payload = await FormPrefillService.fetchPrefill(
        this.statePasien.rm,
        FORM_KEY,
        {
          register_id: this.register,
          unit_id: this.user?.unit_id || "",
          sources: PREFILL_SOURCES
        }
      );

      const fields = (payload && payload.fields) || {};
      const terisi: string[] = [];

      const sistole = teks(fields["nb.sistole"]);
      const diastole = teks(fields["nb.diastole"]);
      if (sistole || diastole) {
        this.td = `${sistole}/${diastole}`;
        if (sistole) terisi.push("nb.sistole");
        if (diastole) terisi.push("nb.diastole");
      }

      const nadi = teks(fields["nb.nadi"]);
      if (nadi) {
        this.nadi = nadi;
        terisi.push("nb.nadi");
      }

      const tb = teks(fields["nb.tb"]);
      if (tb) {
        this.tb = tb;
        terisi.push("nb.tb");
      }

      const bb = teks(fields["nb.bb"]);
      if (bb) {
        this.bb = bb;
        terisi.push("nb.bb");
      }

      if (terisi.length > 0) {
        this.setImt();
        appModule.NoticeDelay(
          terisi.length + " kolom terisi dari catatan kunjungan ini"
        );
        FormPrefillService.logAcceptance({
          form_key: FORM_KEY,
          pasien_rm: this.statePasien.rm,
          register_id: this.register,
          unit_id: this.user?.unit_id || "",
          event: "accepted",
          fields: terisi,
          provenance: (payload && payload.provenance) || {},
          sources: PREFILL_SOURCES
        });
      } else {
        appModule.sendErrorAlert(
          "Belum ada tanda vital atau antropometri yang tercatat pada kunjungan ini"
        );
      }
    } finally {
      this.tarikLoading = false;
    }
  }

  save() {
    if (this.readOnly) return;
    if (!this.saving) {
      this.saving = true;

      const action = this.dataSuket
        ? SuketSehatJasmani.update(this.dataSuket.id, this.input)
        : SuketSehatJasmani.create(this.input);

      action
        .then(() => {
          this.$emit("showSignatureModal", 1000);

          appModule.NoticeDelay("Berhasil Simpan Surat Keterangan Dokter");

          this.close();
          StoreSuketSehatJasmani.getSuketByRegister(this.register);
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }

  close() {
    this.$emit("close");
  }

  formatDate(date) {
    return date ? moment(date, "YYYY-MM-DD").format("DD MMMM YYYY") : "";
  }

  dateFormat(date) {
    return date ? moment(date, "DD-MM-YYYY").format("YYYY-MM-DD") : "";
  }

  uppercaseGolDarah() {
    this.gol_darah = this.gol_darah.toUpperCase();
  }
  @Watch("bb")
  watchBb(v) {
    this.setImt();
  }
  @Watch("tb")
  watchTb(v) {
    this.setImt();
  }
  setImt() {
    if (!this.tb && !this.bb) {
      this.imt = null;
    } else if (this.bb < 1 || this.tb < 1) {
      this.imt = null;
    } else {
      this.imt = (this.bb / Math.pow(this.tb / 100, 2)).toFixed(2);
    }
  }
  ketImt(v) {
    if (v >= 30) {
      return "(Obesitas)";
    } else if (v >= 25) {
      return "(Overweight)";
    } else if (v >= 18.5) {
      return "(Normal)";
    } else if (v >= 0) {
      return "(Underweight)";
    } else {
      return null;
    }
  }
}
